<template>
  <div class="war-room-post-poll-results">
    <WarRoomPostPollChoiceVoted
      v-for="choice in choicesCalculated"
      :key="choice.id"
      :choice="choice"
      class="war-room-post-poll-results__choice"
    />
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import type { IPostPollChoice } from '@/types/community';
import WarRoomPostPollChoiceVoted from '@/components/partials/war-room/WarRoomPostPoll/WarRoomPostPollChoiceVoted/WarRoomPostPollChoiceVoted.vue';
import { round } from '~/components/utils/core/number';
import { sortByField } from '~/components/utils/sorting_func';

export default Vue.extend({
  name: 'WarRoomPostPollResults',
  components: {
    WarRoomPostPollChoiceVoted,
  },
  props: {
    choices: {
      type: Array,
      required: true,
    } as PropOptions<Array<IPostPollChoice>>,
  },
  computed: {
    totalVotesCount() {
      return this.choices.reduce((acc, { votes_count: votesCount }) => acc + votesCount, 0);
    },
    choicesCalculated() {
      return this.choices
        .map(choice => {
          const { votes_count: votesCount, current_vote: currentVote } = choice;

          // @ts-ignore
          const value = this.totalVotesCount && round((votesCount * 100) / this.totalVotesCount);
          return {
            ...choice,
            value: `${value}%`,
            isChosen: !!currentVote,
          };
        })
        .sort(sortByField('position'));
    },
  },
});
</script>

<style scoped lang="scss">
.war-room-post-poll-results {
  &__choice {
    margin-top: 16px;
  }
}
</style>
